import { gql } from '@apollo/client';

export const GET_USER_INVITE_CODE = gql`
  query GetUserInviteCode($code: String!, $email: String!) {
    getUserInviteCode(code: $code, email: $email) {
      _id
    }
  }
`;
